import { Box, SvgIconTypeMap } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import MenuCell from "../../components/common/MenuCell/MenuCell";
import useOrgNavigation from "../../hooks/useOrgNavigation";
import styles from "./Sidebar.module.scss";

interface SidebarButtonProps {
	title: string;
	url?: string;
	matchExact?: boolean;
	iconStart?: ({ stroke }: any) => JSX.Element;
	iconEnd?: ({ stroke }: any) => JSX.Element | SvgIconTypeMap<{}, "svg">;
	badge?: { text: string; color?: string };
	newTab?: boolean;
	visible?: boolean;
	onClick?: (event: any) => void;
	selected?: boolean;
	fullWidth?: boolean;
}

const SidebarButton = ({
	title,
	url,
	iconStart,
	iconEnd,
	badge,
	newTab,
	visible = true,
	matchExact = false,
	onClick,
	selected = false,
	fullWidth = true,
}: SidebarButtonProps) => {
	const { orgNavigationHandler } = useOrgNavigation();
	const location = useLocation();

	if (!visible) return null;

	const isRouteActive =
		url && !matchExact
			? location.pathname === url || location.pathname.startsWith(`${url}/`)
			: location.pathname === url;

	const resolvedSelected = url ? isRouteActive : selected ?? false;

	return (
		<>
			{url ? (
				<NavLink
					to={url}
					className={styles.tabContainer}
					target={newTab ? "_blank" : undefined}
					onClick={(e) => {
						e.preventDefault();
						orgNavigationHandler(url, undefined, newTab);
						onClick?.(e);
					}}
				>
					<MenuCell
						iconStart={iconStart}
						iconEnd={iconEnd}
						newTab={newTab}
						selected={resolvedSelected}
						text={title}
						badge={badge}
						fullWidth={fullWidth}
					/>
				</NavLink>
			) : (
				<Box
					className={styles.tabContainer}
					onClick={(e) => {
						e.preventDefault();
						onClick?.(e);
					}}
				>
					<MenuCell
						iconStart={iconStart}
						iconEnd={iconEnd}
						newTab={newTab}
						selected={resolvedSelected}
						text={title}
						badge={badge}
						fullWidth={fullWidth}
					/>
				</Box>
			)}
		</>
	);
};

export default SidebarButton;
